module.exports = __webpack_public_path__ + "media/images/app/products/bracelets_white_chocolate-3a361839c4b8be83511699ead724d84c.webp";